import api from "./";

export default {
    /**
     * Get card authorizations
     * @param cardId
     * @param params
     */
    getCardAuthorizations(cardId, params) {
        return api
            .get(`/cards/${cardId}/authorizations`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get card transactions
     * @param cardId
     * @param params
     */
    getCardTransactions(cardId, params) {
        return api
            .get(`/cards/${cardId}/transactions`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get linked wallets
     * @param cardId
     * @param params
     */
    getLinkedWallets(cardId, params) {
        return api
            .get(`/cards/${cardId}/wallets`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Set linked wallets
     * @param cardId
     * @param data
     */
    setLinkedWallets(cardId, data) {
        return api.post(`/cards/${cardId}/wallets`, data).then((response) => {
            return response.data;
        });
    },

    /**
     * Get allowed wallets
     * @param cardId
     * @param params
     */
    getAllowedWallets(cardId, params) {
        return api
            .get(`/cards/${cardId}/walletsAllowed`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get allowed payment methods
     * @param cardAuthorization
     * @param params
     */
    getAllowedPaymentMethods(cardAuthorization, params) {
        return api
            .get(`/cardAuthorizations/${cardAuthorization}/paymentMethods`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get allowed types
     * @param cardAuthorization
     * @param params
     */
    getCAAllowedTypes(cardAuthorization, params) {
        return api
            .get(`/cardAuthorizations/${cardAuthorization}/allowedTypes`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get cards authorizations
     * @param params
     */
    getAuthorizations(params) {
        return api
            .get(`/cardAuthorizations`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Show card authorization
     * @param cardAuthorization
     * @param params
     */
    showAuthorization(cardAuthorization, params) {
        return api
            .get(`/cardAuthorizations/${cardAuthorization}`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Update card authorization
     * @param cardAuthorization
     * @param data
     */
    updateAuthorization(cardAuthorization, data) {
        return api
            .put(`/cardAuthorizations/${cardAuthorization}`, data)
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Set partner for card authorization
     * @param cardAuthorization
     * @param data
     */
    setCardAuthorizationPartner(cardAuthorization, data) {
        return api
            .post(`/cardAuthorizations/${cardAuthorization}/setPartner`, data)
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get cards
     * @param params
     */
    get(params) {
        return api
            .get(`/cards`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Show card
     * @param cardId
     * @param params
     */
    show(cardId, params) {
        return api
            .get(`/cards/${cardId}`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Delete card
     * @param cardId
     */
    deleteCard(cardId) {
        return api.delete(`/cards/${cardId}`).then((response) => {
            return response.data;
        });
    },

    /**
     * Reveal cad
     * @param cardId
     * @param params
     */
    reveal(cardId, params) {
        return api
            .get(`/cards/${cardId}/reveal`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get card transfers
     * @param cardId
     * @param params
     */
    getTransfers(cardId, params) {
        return api
            .get(`/cards/${cardId}/transfers`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Update Pin
     * @param cardId
     * @param data
     */
    updatePin(cardId, data) {
        return api.put(`/cards/${cardId}/updatePin`, data).then((response) => {
            return response.data;
        });
    },

    /**
     * Freeze card
     * @param cardId
     * @param data
     */
    freeze(cardId, data) {
        return api.post(`/cards/${cardId}/freeze`, data).then((response) => {
            return response.data;
        });
    },

    /**
     * Unfreeze card
     * @param cardId
     * @param data
     */
    unfreeze(cardId, data) {
        return api.post(`/cards/${cardId}/unfreeze`, data).then((response) => {
            return response.data;
        });
    },

    /**
     * Stop card
     * @param cardId
     * @param data
     */
    stop(cardId, data) {
        return api.post(`/cards/${cardId}/stop`, data).then((response) => {
            return response.data;
        });
    },

    /**
     * Replace card
     * @param cardId
     * @param data
     */
    replace(cardId, data) {
        return api.post(`/cards/${cardId}/replace`, data).then((response) => {
            return response.data;
        });
    },

    /**
     * Payment transactions
     * @param cardTransaction
     * @param params
     */
    getPaymentTransactions(cardTransaction, params) {
        return api
            .get(`/cardTransactions/${cardTransaction}/paymentTransactions`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Payment methods allowed
     * @param cardTransactionId
     * @param params
     */
    getPaymentMethodsAllowed(cardTransactionId, params) {
        return api
            .get(
                `/cardTransactions/${cardTransactionId}/paymentMethodsAllowed`,
                {
                    params: params,
                }
            )
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Payment methods
     * @param cardTransactionId
     * @param params
     */
    getPaymentMethods(cardTransactionId, params) {
        return api
            .get(`/cardTransactions/${cardTransactionId}/paymentMethods`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get allowed types
     * @param cardTransactionId
     * @param params
     */
    getCTAllowedTypes(cardTransactionId, params) {
        return api
            .get(`/cardTransactions/${cardTransactionId}/allowedTypes`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Switch payment methods
     * @param cardTransactionId
     * @param data
     */
    switchPaymentMethods(cardTransactionId, data) {
        return api
            .post(
                `/cardTransactions/${cardTransactionId}/switchPaymentMethods`,
                data
            )
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Report a problem with a card transaction
     * @param cardTransactionId
     * @param data
     */
    reportTransactionProblem(cardTransactionId, data) {
        return api
            .post(`/cardTransactions/${cardTransactionId}/reportProblem`, data)
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Report a problem with a card authorization
     * @param cardAuthorizationId
     * @param data
     */
    reportAuthorizationProblem(cardAuthorizationId, data) {
        return api
            .post(
                `/cardAuthorizations/${cardAuthorizationId}/reportProblem`,
                data
            )
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Add types to card authorization
     * @param cardAuthorizationId
     * @param data
     */
    addTypesToAuthorization(cardAuthorizationId, data) {
        return api
            .post(
                `/cardAuthorizations/${cardAuthorizationId}/classify-types`,
                data
            )
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get all card transactions
     * @param params
     */
    getAllCardsTransactions(params) {
        return api
            .get(`/cardTransactions`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Show card transactions
     * @param cardTransaction
     * @param params
     */
    showCardTransactions(cardTransaction, params) {
        return api
            .get(`/cardTransactions/${cardTransaction}`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * xPay
     * @param card
     * @param config
     */
    xPay(card, config) {
        return api.get(`/cards/${card}/xPay`, config).then((response) => {
            return response.data;
        });
    },

    /**
     * Get an ephemeral key from Stripe
     * @param card
     * @param data
     */
    ephemeralKey(card, data, config) {
        return api
            .post(`/cards/${card}/ephemeralKey`, data, config)
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get tokens for card
     * @param card
     * @param data
     */
    getTokens(card, data) {
        return api.get(`/cards/${card}/tokens`, data).then((response) => {
            return response.data;
        });
    },

    /**
     * Get token for card
     * @param card
     * @param token
     * @param data
     */
    getToken(card, token) {
        return api.get(`/cards/${card}/tokens/${token}`).then((response) => {
            return response.data;
        });
    },

    /**
     * Update card tokens
     * @param card
     * @param token
     * @param data
     */
    updateToken(card, token, data) {
        return api
            .put(`/cards/${card}/tokens/${token}`, data)
            .then((response) => {
                return response.data;
            });
    },
};
